import { flattenLocaleMessages } from '@mi-front/core';
import { uiLocaleMessages } from '@mi-front/ui';

// 👇 Vite will statically watch all these files for HMR.
const msgModules = import.meta.glob('./messages/*.json', {
  eager: true,
}) as Record<`./messages/${string}.json`, { default: Record<string, any> }>;

function pickAppMessages(lang: string): Record<string, any> | undefined {
  const mod = msgModules[`./messages/${lang}.json`];

  if (!mod) {
    return;
  }

  return flattenLocaleMessages(mod.default);
}

function loadUiMessages(lang: string) {
  return (uiLocaleMessages as any)[lang];
}

export function getLocaleMessages(locale: string): Record<string, any> | undefined {
  const language = locale.substring(0, 2).toLowerCase();
  const appMessages = pickAppMessages(language);

  if (!appMessages) {
    return undefined;
  }

  const uiMessages = loadUiMessages(language);

  return {
    ...uiMessages,
    ...appMessages,
  };
}
